import { DocumentType} from'../../Models/document-type'

export const DOCUMENTTYPES: DocumentType[] = [

]
